import React from 'react';
import cn from 'classnames';
import {createUseStyles} from 'react-jss';

export default function FormWrapper({children}: React.PropsWithChildren<any>) {
  const formStyles = createUseStyles({
    formWidth: {
      maxWidth: '818px'
    }
  });

  return (
    <div className={cn('pb-8 pb-20', formStyles().formWidth)}>
      {children}
    </div>
  );
}
